import { Link, PropertyFilterProps } from "@amzn/awsui-components-react-v3"
import React from 'react';

export const PropertyFilteri18nStrings = {
    filteringAriaLabel: "your choice",
    dismissAriaLabel: "Dismiss",
    filteringPlaceholder: "Search",
    groupValuesText: "Values",
    groupPropertiesText: "Entities",
    operatorsText: "Operators",
    operationAndText: "and",
    operationOrText: "or",
    operatorLessText: "Less than",
    operatorLessOrEqualText: "Less than or equal",
    operatorGreaterText: "Greater than",
    operatorGreaterOrEqualText:
      "Greater than or equal",
    operatorContainsText: "Contains",
    operatorDoesNotContainText: "Does not contain",
    operatorEqualsText: "Equals",
    operatorDoesNotEqualText: "Does not equal",
    editTokenHeader: "Edit filter",
    propertyText: "Property",
    operatorText: "Operator",
    valueText: "Value",
    cancelActionText: "Cancel",
    applyActionText: "Apply",
    allPropertiesLabel: "All properties",
    tokenLimitShowMore: "Show more",
    tokenLimitShowFewer: "Show fewer",
    clearFiltersText: "Clear entity",
    removeTokenButtonAriaLabel: () => "Remove token",
    enteredTextLabel: text => ""
}

export const EQUAL_COMPARISION : PropertyFilterProps.ComparisonOperator[] = ['='];
export const FILTER_PROPS_FOR_ENTITY_SEARCH = [
  {
    key: "node",
    operators: EQUAL_COMPARISION,
    propertyLabel: "Node",
    groupValuesLabel: "Node Names",
    group: "NodeGroup"
  },
  {
    key: "workflowId",
    operators: EQUAL_COMPARISION,
    propertyLabel: "Workflow Id",
    groupValuesLabel: "Workflow Ids",
    group: "WorkflowGroup"
  },
];

export const GROUPS_FOR_ENTITY_SEARCH = [
  {
    properties: "Nodes",
    values: "Node Name",
    group: "NodeGroup"
  },
  {
    properties: "Workflows",
    values: "Workflow Id",
    group: "WorkflowGroup"
  }
]

export const HELP_FOR_SEARCH = 
<div>
  <p>Choose a search filter (Node, Workflow Id), followed by the operator, and provide the value. If no filter is selected, the default is Node.</p>
  <ul>
    <li>Node (default) - Search a node (of any type) by name. Eg: Node = ABC1</li>
    <li>Workflow Id - Get list of entities by workflow ID. Eg: Workflow Id = RAD_WORKFLOW</li>
  </ul>
</div>